import get from 'lodash/get'

import { renderChartTooltip } from './chartTooltip'
import { renderTableTooltip } from './tableTooltip'

const TABLE_TOOLTIP_BREAKPOINT = 640

// `this` is a chart ctx.
// see: https://www.chartjs.org/docs/latest/general/options.html#scriptable-options
// see: https://www.chartjs.org/docs/latest/configuration/tooltip.html#external-custom-tooltips
export function customTooltip (ctx) {
  const chartWidth = get(ctx, 'chart.width', TABLE_TOOLTIP_BREAKPOINT)
  const useTableTooltip = chartWidth < TABLE_TOOLTIP_BREAKPOINT

  if (useTableTooltip) {
    renderTableTooltip(ctx)
  } else {
    renderChartTooltip(ctx)
  }
}
